// DodoSkills subject colours -- see Logo.tsx for the brand system.

export type Subject = 'maths' | 'english';

export const SUBJECT_COLOURS: Record<
  Subject | 'umbrella',
  // dark: the bird's head. light: the tile behind it. beak: the one accent.
  // (tile/bird are the same two colours under their older names, kept so
  // nothing else that reads them has to change.)
  { tile: string; bird: string; beak: string }
> = {
  // Current app palette: forest-950 and mint, with the brand amber beak.
  maths: { tile: '#113024', bird: '#d1fae5', beak: '#b45309' },
  // Reserved for English: deep indigo and pale lavender (not used on the
  // site until English launches).
  english: { tile: '#2e2a6b', bird: '#e4e1ff', beak: '#b45309' },
  // Parent brand on its own (e.g. the company footer, documents).
  umbrella: { tile: '#14211c', bird: '#f7f6f2', beak: '#b45309' },
};
